export default __webpack_public_path__ + "static/leftCard-75db5d052024d84ee3fcabcdf58ffd75.png";